import _createForOfIteratorHelper from "@babel/runtime/helpers/createForOfIteratorHelper";
import BabelTraverse from "@babel/traverse";
import { parseChildren } from "./parseChildren.js";
import { parseJsValue } from "./parseJsValue.js";
import { getViewTitle } from "./getViewTitle.js";
var traverse = process.env.NODE_ENV === "test" ? BabelTraverse : BabelTraverse["default"];
export function parseLegacyModule(filePath, app, ast, options) {
  var _ast$errors;
  var errors = [];
  if ((_ast$errors = ast.errors) !== null && _ast$errors !== void 0 && _ast$errors.length) {
    var _iterator = _createForOfIteratorHelper(ast.errors),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var error = _step.value;
        errors.push({
          message: "".concat(error.code, ": ").concat(error.reasonCode),
          node: null,
          severity: "error"
        });
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  var bindingMap = new Map();
  var component = {
    type: "view",
    bindingMap: bindingMap
  };
  var globalOptions = {
    component: component,
    stateBindings: options === null || options === void 0 ? void 0 : options.withContexts
  };
  var file = app.files.find(function (f) {
    return f.filePath === filePath;
  });
  var mod = {
    source: file.content,
    filePath: filePath,
    moduleType: "entry",
    defaultExport: {
      type: "view",
      component: component
    },
    internals: [],
    namedExports: new Map(),
    errors: errors,
    contracts: new Set(),
    usedHelpers: new Set()
  };
  traverse(ast, {
    Program: function Program(path) {
      var body = path.get("body");
      var exported = false;
      var _iterator2 = _createForOfIteratorHelper(body),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var stmt = _step2.value;
          if (stmt.isVariableDeclaration()) {
            if (exported) {
              errors.push({
                message: "Unexpected variable declaration after export",
                node: stmt.node,
                severity: "error"
              });
              continue;
            }
            if (stmt.node.kind !== "const") {
              errors.push({
                message: "Only \"const\" variable declaration is allowed, received: ".concat(stmt.node.kind),
                node: stmt.node,
                severity: "error"
              });
              continue;
            }
            var _iterator3 = _createForOfIteratorHelper(stmt.get("declarations")),
              _step3;
            try {
              for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                var decl = _step3.value;
                var declId = decl.get("id");
                if (!declId.isIdentifier()) {
                  errors.push({
                    message: "Unsupported variable declaration pattern, expected: Identifier, received: ".concat(declId.type),
                    node: declId.node,
                    severity: "error"
                  });
                  continue;
                }
                var binding = {
                  id: declId.node,
                  kind: "constant"
                };
                var init = decl.get("init");
                if (init.node) {
                  binding.initialValue = parseJsValue(init, mod, app, globalOptions);
                }
                bindingMap.set(declId.node, binding);
              }
            } catch (err) {
              _iterator3.e(err);
            } finally {
              _iterator3.f();
            }
          } else if (stmt.isExportDefaultDeclaration()) {
            exported = true;
            var _decl = stmt.get("declaration");
            if (!_decl.isJSXElement()) {
              errors.push({
                message: "Default export must be a JSX element, received: ".concat(_decl.type),
                node: stmt.node,
                severity: "error"
              });
            } else {
              component.children = parseChildren(_decl, mod, app, globalOptions);
            }
            break;
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      path.stop();
    }
  });
  mod.defaultExport.title = getViewTitle(component);
  app.modules.set(filePath, mod);
  app.entry = mod;
}
//# sourceMappingURL=parseLegacyModule.js.map